function $runUFUNC() {
  for (const k in this.$computeds) {
    this.$updateUFUNC(k, this.$computeds[k]);
  }
}
function $updateUFUNC(designId, ufunc) {
  if (!this.$ufuncWatchs) {
    this.$ufuncWatchs = {};
  }
  let oldWatch = this.$ufuncWatchs[designId];
  if (oldWatch) {
    //销毁老监听器
    oldWatch();
    delete this.$ufuncWatchs[designId];
  }
  let uw = $UFUNCWatch.call(this, ufunc);
  this.$ufuncWatchs[designId] = uw;
}
function $registerUFUNC(designId, ufunc) {
  this.$computeds[designId] = ufunc;
  if (this.$isDataLoaded) {
    this.$updateUFUNC(designId, ufunc);
  }
}
function $unRegisteUFUNC(designId, ufunc) {
  this.$data.$computeds?.[designId] && delete this.$data.$computeds[designId];
  const uw = this.$ufuncWatchs?.[designId];
  if (uw && dsf.isFunction(uw)) {
    uw();
    delete this.$ufuncWatchs[designId];
  }
}

//计算公式监听
function $UFUNCWatch(ufunc) {
  let _this = this;
  //判断第一次监听调用，第一次监听调用是个vue依赖收集过程，如果immediate为false时候不会触发变化处理函数
  let depCall = true;
  const watchFn = function () {
    let result = null;
    if (this.$isDataLoaded) {
      const uf = dsf.isFunction(ufunc) ? ufunc() : ufunc;
      const { computed, self } = uf;
      let local = self.local;
      result = computed.call(this, _this, local);
      let valStr = result + "";
      // 使用正则表达式检查特殊字符串
      let isSpecial = valStr.match(/NaN|Infinity|undefined|null/);
      if (isSpecial) {
        return null;
      }
    }
    if (depCall) {
      depCall = false;
      return null;
    }
    return result;
  };
  const watchHandler = function (v) {
    ufunc.model.callback.call(this, v);
  };
  let uw = this.$watch(watchFn, watchHandler, {
    // deep: true,
    immediate: ufunc.immediate
  });
  return uw;
}

export { $runUFUNC, $updateUFUNC, $registerUFUNC, $unRegisteUFUNC, $UFUNCWatch };
